
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nos-dossiers/[slug]",
      function () {
        return require("private-next-pages/nos-dossiers/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nos-dossiers/[slug]"])
      });
    }
  